import {
  CORPUS_QA,
  PAPER_FINDER,
  TABLE_ANNOTATION,
} from 'configs/NoraVariants';
import { getStepProgressListFromStateByMessageId } from '@/store/reducers/StepProgressStore';
import { Message } from '@/models/Message';
import { MessageBubble } from '@/components/chat/MessageBubble';
import { optAppConfig } from '@/utils/config';
import { RootState } from '@/store/store';
import { Step } from '@/components/chat/Step';
import { StepProgress, StepRunState } from '@/models/StepProgress';
import { UserIcon } from '@/components/chat/UserIcon';

import { connect } from 'react-redux';
import { styled } from '@mui/material';

export interface PropsFromState {
  stepProgressList: StepProgress[];
}

export interface MessageStepProps {
  message: Message;
  renderUserIcon?: boolean;
}

export type Props = MessageStepProps & PropsFromState;

export const MessageStepsComp = ({
  message,
  stepProgressList,
  renderUserIcon = true,
}: Props) => {
  const noraExperienceVariant = optAppConfig((_) => _.experience.variant);
  const botActorId = optAppConfig((_) => _.bot.actor_id);

  let filteredStepProgressList = stepProgressList;
  const shouldHideHandlerSteps =
    noraExperienceVariant === CORPUS_QA ||
    noraExperienceVariant === PAPER_FINDER;

  if (noraExperienceVariant !== TABLE_ANNOTATION) {
    // HACK: Remove the "processing user prompt" step if it has succeeded
    filteredStepProgressList = stepProgressList.filter(
      (stepProgress) =>
        !(
          (stepProgress.shortDescription === 'processing user prompt' &&
            stepProgress.runState === StepRunState.SUCCEEDED) ||
          // Remove any handler step progress for the certain variants
          (shouldHideHandlerSteps && stepProgress.actorId === botActorId)
        ),
    );
  }
  if (filteredStepProgressList.length === 0) {
    return null;
  }

  const stepList = (
    <StepList>
      {filteredStepProgressList.map((stepProgress) => (
        <Step key={stepProgress.stepId} stepProgress={stepProgress} />
      ))}
    </StepList>
  );

  if (!renderUserIcon) {
    return stepList;
  }

  return (
    <MessageBubble
      icon={<UserIcon message={message} isAsta />}
      content={stepList}
    />
  );
};

const mapStateToProps = (
  state: RootState,
  { message }: MessageStepProps,
): PropsFromState => {
  const stepProgressList = getStepProgressListFromStateByMessageId(
    state.stepProgressStore,
    message.id,
  );
  return {
    stepProgressList, // HACK: This list is not memoized, which may cause perf issues
  };
};

export const MessageSteps = connect(mapStateToProps)(MessageStepsComp);

export const StepList = styled('div')`
  display: inline-flex;
  flex-direction: column;
  max-width: 600px;
  width: 100%;
`;
